/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BannerResponse
 */
export interface BannerResponse {
    /**
     * 
     * @type {string}
     * @memberof BannerResponse
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof BannerResponse
     */
    bannerStartUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof BannerResponse
     */
    maintenanceStartUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof BannerResponse
     */
    maintenanceEndUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof BannerResponse
     */
    message: string | null;
}

/**
 * Check if a given object implements the BannerResponse interface.
 */
export function instanceOfBannerResponse(value: object): value is BannerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('bannerStartUtc' in value) || value['bannerStartUtc'] === undefined) return false;
    if (!('maintenanceStartUtc' in value) || value['maintenanceStartUtc'] === undefined) return false;
    if (!('maintenanceEndUtc' in value) || value['maintenanceEndUtc'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function BannerResponseFromJSON(json: any): BannerResponse {
    return BannerResponseFromJSONTyped(json, false);
}

export function BannerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BannerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bannerStartUtc': (new Date(json['bannerStartUtc'])),
        'maintenanceStartUtc': (new Date(json['maintenanceStartUtc'])),
        'maintenanceEndUtc': (new Date(json['maintenanceEndUtc'])),
        'message': json['message'],
    };
}

export function BannerResponseToJSON(json: any): BannerResponse {
    return BannerResponseToJSONTyped(json, false);
}

export function BannerResponseToJSONTyped(value?: BannerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bannerStartUtc': value['bannerStartUtc'].toISOString(),
        'maintenanceStartUtc': value['maintenanceStartUtc'].toISOString(),
        'maintenanceEndUtc': value['maintenanceEndUtc'].toISOString(),
        'message': value['message'],
    };
}

